export const PICKLEJAR_DEFAULT_ID_VALIDATION_BACK_IMAGE = '/images/idVerification/idVerificationBack.svg';
export const PICKLEJAR_DEFAULT_ID_VALIDATION_FRONT_IMAGE = '/images/idVerification/idVerificationFront.svg';
export const PICKLEJAR_DEFAULT_ID_VALIDATION_VIDEO_IMAGE = '/images/idVerification/idVerificationVideo.png';
